export default __webpack_public_path__ + "static/media/img12.b303e865.png";